/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/merkliste-menu/shop.merkliste-menu.component.ts.
 */
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {AppPageloaderService} from '../../../../services/app.pageloader.service';
import {AppMerklisteService} from '../../../../services/app.merkliste.service';
import {BehaviorSubject} from 'rxjs';
import {Merkliste} from '../../../../models/merkliste';
import {MerklistActionInfo} from '../../../../models/merklist-action-info';
import {ShopMerklisteActionInfoComponent} from '../merkliste-action-info/shop.merkliste-action-info.component';
import {Artikel} from '../../../../models/artikel';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {AppSnackbarService} from '../../../../services/app.snackbar.service';
import {AppUserService} from '../../../../services/app.user.service';

/**
 * Zweck: Beschreibt class ShopMerklisteMenuComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.merkliste-menu.component.html',
    styleUrls: ['shop.merkliste-menu.component.scss'],
    standalone: false
})
export class ShopMerklisteMenuComponent implements OnInit, OnDestroy {
  static id = 'ShopMerklisteMenuComponent';
  merklisten: Merkliste[];

  primary_merkliste = new BehaviorSubject<Merkliste>(null);

  add_mode = false;

  newml: Merkliste;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private loader: AppPageloaderService, public mlsvc: AppMerklisteService,
              private snackBarSvc: AppSnackbarService, private _bottomSheetRef: MatBottomSheetRef<ShopMerklisteMenuComponent>,
              public usvc: AppUserService,
              @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
                artikel: Artikel,
                view_slug: string,
                entry: WarenkorbEntry
              }) {
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {

  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {

  }

/**
 * Beschreibt Methode save und ihren Rückgabevertrag.
 */
  save() {
    this.loader.start('ShopViewActionComponent_' + this.data.artikel.ArtikelNummer + '_11');
    this.mlsvc.createMerkliste(this.newml).subscribe(ml => {
      this.loader.stop('ShopViewActionComponent_' + this.data.artikel.ArtikelNummer + '_11');
      this.addToMerkliste(ml);
      this._bottomSheetRef.dismiss();
    });
  }

/**
 * Beschreibt Methode cancel und ihren Rückgabevertrag.
 */
  cancel() {
    this.add_mode = false;
    this.newml = undefined;
  }

/**
 * Beschreibt Methode add und ihren Rückgabevertrag.
 */
  add() {
    this.newml = new Merkliste();
    this.newml.label = 'Neue Merkliste';
    this.newml.shared = true;
    this.add_mode = true;
  }


/**
 * Beschreibt Methode addToPrimaryMerkliste und ihren Rückgabevertrag.
 */
  addToPrimaryMerkliste() {
    return this.addToMerkliste(this.mlsvc.primary_merkliste.value);
  }

/**
 * Beschreibt Methode addToMerkliste und ihren Rückgabevertrag.
 */
  addToMerkliste(ml: Merkliste) {
    this.loader.start('ShopViewActionComponent_' + this.data.artikel.ArtikelNummer + '_1');

    this.mlsvc.addToMerklisteById(
      ml.id,
      this.data.view_slug,
      this.data.artikel.ArtikelNummer,
      this.data.entry.menge
    ).subscribe(m => {
      this.loader.stop('ShopViewActionComponent_' + this.data.artikel.ArtikelNummer + '_1');

      this.data.entry.menge = 1;

      const i = new MerklistActionInfo();
      i.action = 'add';
      i.info = m;

      this.snackBarSvc.open(ShopMerklisteActionInfoComponent, i, 2500);
      this._bottomSheetRef.dismiss();
    });
  }

}
